import './assets/css/App.css';
import './assets/css/leaflet.css';
import * as Sentry from '@sentry/react';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './components/Header';
import Main from './components/Main';
import Fab from '@mui/material/Fab';
import theme from './theme';
import ScrollTop from './components/forms/ScrollTop';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header />
      <Main />
      <ScrollTop>
        <Fab
          size="small"
          aria-label="scroll back to head section"
          color="primary"
          sx={{ borderRadius: 0 }}
        >
          <ArrowUpwardIcon />
        </Fab>
      </ScrollTop>
    </ThemeProvider>
  );
}

export default Sentry.withProfiler(App);
